import i18next from 'i18next';
import numeral from 'numeral';

import { TIMEZONE } from '~constants/environment';
import { getNumeralLocale } from '~config/numeral';

export const getLocale = (countryCode) => `es_${countryCode}`;

function requireAllI18nFiles() {
  const context = require.context('..', true, /i18n\.js$/);
  return context.keys().map((key) => {
    try {
      context.resolve(key);
      return context(key);
    } catch (error) {
      console.log(error);
    }
  });
}

class Internationalization {
  isoCountry = 'cl';

  currencySymbol = '$';

  codeCountry = '+569';

  language = 'es_CL';

  initialized = false;

  timezone = TIMEZONE.cl;

  withCents = false;

  constructor() {
    this.initialized = false;
  }

  async init(settings) {
    if (!this.initialized) {
      const country = (settings.country?.isoCountry || 'cl').toLowerCase();
      const currencySymbol = settings.country?.currencySymbol || '$';
      const countryCode = settings.country?.codeCountry || '+569';
      const withCents = settings.country?.withCents || false;

      this.isoCountry = country;
      this.currencySymbol = currencySymbol;
      this.codeCountry = countryCode;
      this.language = `es_${country.toUpperCase()}`;
      this.timezone = TIMEZONE[country] || TIMEZONE.default;
      this.withCents = withCents;

      i18next.init({
        lng: intl.language,
        initImmediate: false,
        fallbackLng: ['es_CL']
      });

      await Promise.all(requireAllI18nFiles());

      numeral.locale(getNumeralLocale(this.isoCountry));
      this.initialized = true;
    }
  }
}

export const intl = new Internationalization();
